@if (entry) {
  <div class="detail-form">
    <div class="row mt-md-2">
      <div class="col-md-6 col-sm-12">
        <cap-kopfdatenelement [histInfo]="entry?.version.histInfo" label="Bezeichnung">
          <cap-link
            [params]="[entry.masterId.id, entry.version.id.id]"
            [target]="navTargets.NAV_PERSON_STAMM"
            [tooltipParams]="entry | tooltipPersonstammPipe">
            <cap-kompakt-stammperson [item]="entry?.version"></cap-kompakt-stammperson>
          </cap-link>
        </cap-kopfdatenelement>
      </div>
      <div class="col-md-6 col-sm-12">
        <cap-kopfdatenelement [value]="entry.datenquelle | translate" label="Datenquelle"></cap-kopfdatenelement>
      </div>
    </div>
    <h3 class="mb-1 mt-0">{{ "AdressenN" | translate }}</h3>
    @if (showAdressen(entry.auskunftsperre)) {
      <cap-personstamm-adressen
        [auskunftsperre]="entry.auskunftsperre"
        [entry]="entry?.version"
        [listLoader]="adressen"></cap-personstamm-adressen>
    } @else {
      <div>
        <span style="font-style: italic">{{ "stammperson-adresssperre" | translate }}</span>
      </div>
    }
  </div>
} @else {
  <cap-spinner-small></cap-spinner-small>
}
